// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
    background-color: #333;
    color: #fff;
    padding: 2rem 0;
    font-family: Arial, sans-serif;
}

.footer-content {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    max-width: 1200px;
    margin: 0 auto;
}

.footer-section {
    flex: 1 1;
    margin: 1rem;
    min-width: 200px;
}

.footer-section h3 {
    color: #fff;
    font-size: 1.2rem;
    margin-bottom: 0.7rem;
}

.footer-section ul {
    list-style-type: none;
    padding: 0;
}

.footer-section ul li {
    margin-bottom: 0.4rem;
}

.footer-section ul li a {
    color: #ddd;
    text-decoration: none;
    transition: color 0.3s ease;
    display: block;
    padding: 0;
}

.footer-section ul li a:hover {
    color: #fff;
}

.text-link {
    color: #ddd;
    text-decoration: none;
    transition: color 0.3s ease;
    display: inline-block;
    margin: 0.1rem 0;
    padding: 0;
}

.text-link:hover {
    color: #fff;
}

.footer-section p {
    margin: 0.4rem 0;
    line-height: 1.2;
}

.footer-bottom {
    text-align: center;
    padding-top: 1.5rem;
    margin-top: 1.5rem;
    border-top: 1px solid #555;
}`, "",{"version":3,"sources":["webpack://./src/styles/Footer.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,2BAA2B;IAC3B,cAAc;IACd,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,2BAA2B;IAC3B,qBAAqB;IACrB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;AAC9B","sourcesContent":[".footer {\n    background-color: #333;\n    color: #fff;\n    padding: 2rem 0;\n    font-family: Arial, sans-serif;\n}\n\n.footer-content {\n    display: flex;\n    justify-content: space-around;\n    flex-wrap: wrap;\n    max-width: 1200px;\n    margin: 0 auto;\n}\n\n.footer-section {\n    flex: 1;\n    margin: 1rem;\n    min-width: 200px;\n}\n\n.footer-section h3 {\n    color: #fff;\n    font-size: 1.2rem;\n    margin-bottom: 0.7rem;\n}\n\n.footer-section ul {\n    list-style-type: none;\n    padding: 0;\n}\n\n.footer-section ul li {\n    margin-bottom: 0.4rem;\n}\n\n.footer-section ul li a {\n    color: #ddd;\n    text-decoration: none;\n    transition: color 0.3s ease;\n    display: block;\n    padding: 0;\n}\n\n.footer-section ul li a:hover {\n    color: #fff;\n}\n\n.text-link {\n    color: #ddd;\n    text-decoration: none;\n    transition: color 0.3s ease;\n    display: inline-block;\n    margin: 0.1rem 0;\n    padding: 0;\n}\n\n.text-link:hover {\n    color: #fff;\n}\n\n.footer-section p {\n    margin: 0.4rem 0;\n    line-height: 1.2;\n}\n\n.footer-bottom {\n    text-align: center;\n    padding-top: 1.5rem;\n    margin-top: 1.5rem;\n    border-top: 1px solid #555;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
